import { FormField, LoadingBubbles } from '@domain-group/suit-theme'

import type { PublicationModel } from '@models/types'

import PublicationTile from '@components/PublicationTile'

interface PublicationSelectorProps {
  callbacks: {
    selectPublication: (publication: PublicationModel) => void,
  },
  loading: boolean,
  publications: PublicationModel[],
}

const PublicationSelector = (props: PublicationSelectorProps) => {
  const {
    callbacks: {
      selectPublication,
    },
    loading = false,
    publications,
  } = props

  return (
    <FormField
      label="Select Publication"
      labelProps={{ flexShrink: 0, width: 'auto' }}
      labelRight={loading && (
        <LoadingBubbles color="blue" style={{ marginLeft: 'auto', width: 'auto' }} />
      )}
    >
      {publications.map(publication => (
        <PublicationTile
          callbacks={{
            selectPublication: () => selectPublication(publication),
          }}
          key={publication.id}
          publication={publication}
        />
      ))}
    </FormField>
  )
}

export default PublicationSelector
